import {useQuery} from "@tanstack/react-query";
import {
    GetGuildProgressResponse,
    GuildsApi,
    Token,
} from "@devour/client";
import getConfig from "@/utils/getConfig";
import { CACHE_TIMES } from "@/config/queryCacheConfig";

async function fetchGuildProgress(guildId: string, freshCopy?: boolean): Promise<GetGuildProgressResponse> {
    return await new GuildsApi(getConfig()).getGuildProgress({
        id: guildId,
        freshCopy: freshCopy,
    });
}

function getGuildProgressQuery(guildId: string, fullToken?: Token, freshCopy?: boolean, enabled?: boolean) {
    return {
        queryKey: [
            "get-guild-progress",
            guildId,
            fullToken?.id ?? "unauthenticated",
            freshCopy,
        ],
        queryFn: () => guildId ? fetchGuildProgress(guildId, freshCopy) : null,
        staleTime: CACHE_TIMES.DYNAMIC.staleTime,
        cacheTime: CACHE_TIMES.DYNAMIC.cacheTime,
        enabled: Boolean(guildId) && enabled,
    } as const;
}

export function useGetGuildProgress(guildId: string, fullToken?: Token, freshCopy?: boolean, enabled?: boolean) {
    return useQuery(getGuildProgressQuery(guildId, fullToken, freshCopy, enabled));
}